import React, { useContext } from "react";

import {
  Box,
  Button,
  Grid,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import clsx from "clsx";
import { Clipboard } from "react-feather";
import { Link } from "react-router-dom";

import mainStyles from "../../../styles";
import { SearchTableBodyRowSubSearchProps } from "../../../types/search-display";
import { SnackbarContext } from "context/snackbar-context";

const TableBodyRowSubscriptionSearch = ({
  row,
  regionCode,
}: SearchTableBodyRowSubSearchProps) => {
  const classes = mainStyles();
  const theme = useTheme();

  const { copyToClipboard } = useContext(SnackbarContext);

  let firstName = "-";
  let lastName = "-";
  let maskedCreditCard = "----";
  const chargify = row.chargify;
  const billingDetails = chargify ? chargify.billingDetails : undefined;
  if (billingDetails !== undefined) {
    firstName = billingDetails.firstName;
    lastName = billingDetails.lastName;
    maskedCreditCard = billingDetails.maskedCardNumber;
  }

  return (
    <TableRow>
      <TableCell>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography
              align="left"
              variant="body1"
              gutterBottom
              sx={classes.clickable}
              onClick={() => copyToClipboard(row.owner)}
            >
              <Box component="span" fontWeight="fontWeightBold">
                {row.owner}
              </Box>{" "}
              <Clipboard
                color={theme.palette.text.primary}
                size={"1rem"}
                className="position-icon"
              />
            </Typography>
            <Typography align="left" variant="body1">
              {`${firstName} ${lastName}`}
            </Typography>
            <Typography align="left" variant="body1">
              {maskedCreditCard}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Link
                to={`organisation/${regionCode}/${row.owner}`}
                className="remove-link-style"
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(classes.spaceRightMedium, classes.spaceTop)}
                >
                  Org Details
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default TableBodyRowSubscriptionSearch;
